import { Component } from '@angular/core';

/**
 * Generated class for the BusquedaTesoroActivoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'busqueda-tesoro-activo',
  templateUrl: 'busqueda-tesoro-activo.html'
})
export class BusquedaTesoroActivoComponent {

  text: string;

  constructor() {
    console.log('Hello BusquedaTesoroActivoComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/busqueda-tesoro-activo/busqueda-tesoro-activo.ts